import fileService from '../../services/file';

const state = {
    backgrounds: [],
    images: [],
    icons: [],
}

const getters = {
    backgrounds: (state) => state.backgrounds,
    images: (state) => state.images,
    icons: (state) => state.icons,
}

const actions = {
    getImages({ commit }) {
        return fileService.getImages()
            .then((response) => {
                commit('setImages', response.files);

                return response;
            })
    },
}

const mutations = {
    setImages(state, files) {
        state.backgrounds = files.backgrounds
        state.images = files.images
        state.icons = files.icons
    },
}

export const file = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}